module.exports = __webpack_public_path__ + "img/no-image.755a3ea9.png";